import client, { ApiResponse } from './client';

export interface UserProfile {
  address: string;
  nickname: string;
  level: number;
  currentHp: number;
  maxHp: number;
  balance: string;
  exp: number;
  nextLevelExp: number;
  myInvitationCode: string;
}

export const getUserProfile = async (): Promise<UserProfile> => {
  const response = await client.get<ApiResponse<UserProfile>>('/user/profile');
  return response.data.data;
};

export interface CheckInResponse {
  success: boolean;
  isRepeated: boolean;
  reward: number;
  currentBalance: string;
  checkinTime: string;
}

export const checkIn = async (): Promise<CheckInResponse> => {
  const response = await client.post<ApiResponse<CheckInResponse>>('/user/checkin');
  // 后端返回结构（扁平化）：
  // { 
  //   "msg": "操作成功", 
  //   "reward": 100, 
  //   "traceId": null, 
  //   "checkinTime": "...", 
  //   "code": 200, 
  //   "success": true, 
  //   "currentBalance": "1045.00", 
  //   "isRepeated": true 
  // }
  // response.data 是这个整体对象。
  // 注意：client.ts 定义的 ApiResponse 是 { code, msg, data, ... }
  // 但这里后端似乎没有把业务数据放在 data 字段里，而是直接混在了顶层。
  // 或者说，response.data 本身就是我们需要的 CheckInResponse（包含 success, reward 等）。
  
  // 这种情况下，我们强制转换 response.data 为 CheckInResponse
  return response.data as unknown as CheckInResponse;
};

export interface CheckInStatusResponse {
  isCheckedIn: boolean;
}

export const getCheckInStatus = async (): Promise<CheckInStatusResponse> => {
  const response = await client.get<ApiResponse<CheckInStatusResponse>>('/user/checkin/status');
  return response.data.data;
};

export interface SocialAccount {
  platform: 'twitter' | 'discord' | 'github';
  socialUserId: string;
  username?: string;
}

export const getUserSocials = async (): Promise<SocialAccount[]> => {
  const response = await client.get<ApiResponse<SocialAccount[]>>('/user/social/list');
  return response.data.data;
};

export const bindSocialAccount = async (platform: string, token: string, redirectUri?: string, codeVerifier?: string): Promise<boolean> => {
  const payload: any = { platform };
  
  if (platform === 'twitter') {
    payload.code = token; // For Twitter, the 'token' passed here is actually the authorization code
    payload.redirectUri = redirectUri;
    payload.codeVerifier = codeVerifier;
  } else {
    // For others like Discord/GitHub, we might still send 'token' or 'code' depending on flow
    // If token is actually a code (GitHub), backend handles it via bindSocialWithCode if 'token' param is empty?
    // Based on backend logic:
    // if (body.getToken()) -> bindSocialWithToken
    // else -> bindSocialWithCode(code, redirectUri)
    
    // So if we have an access token (Implicit flow), use 'token'
    // If we have a code (PKCE/Auth Code flow), use 'code' and 'redirectUri'
    
    // Let's assume 'token' arg is the primary credential string we got
    // We need to decide where to put it based on platform or length
    
    if (platform === 'github') {
        payload.code = token;
        payload.redirectUri = redirectUri;
    } else {
        payload.token = token;
    }
  }

  const response = await client.post<ApiResponse<boolean>>('/user/social/bind', payload);
  return response.data.data;
};
